// ---------------------------------------------- state interface
export interface IAuthState {
  error: string | null;
}

// ---------------------------------------------- action type enum
export enum AuthActionType {
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGIN_ERROR = "LOGIN_ERROR",
  LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
  LOGOUT_ERROR = "LOGOUT_ERROR"
}

// ---------------------------------------------- action interfaces
interface ILoginSuccess {
  type: typeof AuthActionType.LOGIN_SUCCESS;
}

interface ILoginError {
  type: typeof AuthActionType.LOGIN_ERROR;
  payload: {
    error: string;
  };
}

interface ILogoutSuccess {
  type: typeof AuthActionType.LOGOUT_SUCCESS;
}

interface ILogoutError {
  type: typeof AuthActionType.LOGOUT_ERROR;
  payload: {
    error: string;
  };
}

// ---------------------------------------------- exported action type
export type AuthAction =
  | ILoginSuccess
  | ILoginError
  | ILogoutSuccess
  | ILogoutError;
